import { gsap } from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";

export default class BlockMarquee {
    static init() {
        this.marquees = document.querySelectorAll('.marquee-container');

        if (this.marquees.length > 0) {
            this.marquees.forEach((marqueeContainer) => {
                if (document.fonts) {
                    document.fonts.ready.then(() => {
                        this.initMarquee(marqueeContainer);
                    });
                } else {
                    this.initMarquee(marqueeContainer);
                }
            });

            GlobalVariables.resizeCallbacks.push(this);
        }
    }

    static initMarquee(marqueeContainer, reveal = true) {
        const inner = marqueeContainer.querySelector('.marquee-container-inner');
        const marqueeWords = marqueeContainer.querySelector(".marquee-words");
        const containerWidth = window.innerWidth;

        // Recalcule la largeur des mots
        const wordWidth = marqueeWords.scrollWidth;

        // Nettoie tout contenu cloné précédent
        inner.innerHTML = '';
        inner.appendChild(marqueeWords);

        // Crée des duplications basées sur la largeur de la fenêtre
        const numDuplicates = Math.ceil(containerWidth / (wordWidth)) + 2;

        for (let i = 0; i < numDuplicates; i++) {
            const clone = marqueeWords.cloneNode(true);
            inner.appendChild(clone);
        }

        // Initialise l'animation avec la nouvelle largeur
        gsap.to(inner.querySelectorAll(".marquee-words"), {
            x: `-=${wordWidth}`,
            duration: wordWidth / 80,
            overwrite: "true",
            ease: "none",
            repeat: -1,
        });

        if (reveal) {
            if (!marqueeContainer.dataset.noReveal) {
                const delay = marqueeContainer.dataset.appearDelay ?? 0; // Utilisation de `data-aos-delay`

                const reveal = gsap.timeline({
                    scrollTrigger: {
                        trigger: marqueeContainer,
                        start: "top bottom",
                        end: "top 65%",
                        scrub: marqueeContainer.dataset.appearDelay ? false : true,
                    },
                });

                reveal.to(inner, {
                    delay: parseFloat(delay),
                    y: 0,
                    rotation: 0,
                    duration: 1,
                    ease: "power1.ease",
                });
            }
        }
    }

    static resize() {
        this.marquees.forEach((marqueeContainer) => {
            this.initMarquee(marqueeContainer, false);
        });
    }

}